import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { FormFieldCollectorContext } from "../form/Form";
import { CheckboxCollectionContext } from "./CheckboxCollectionContext";
import Row from "noood/comp/ui/containers/flex-boxes/Row";
import Col from "noood/comp/ui/containers/flex-boxes/Col";
import ColorIcon from "noood/comp/ui/feather-icon/ColorIcon";
import { ArrayUtil } from "noood/util/array/ArrayUtil";
import * as stylex from "@stylexjs/stylex";
export default function Checkbox(props) {
  var _props$checked;
  var form_collector = useContext(FormFieldCollectorContext);
  var checkbox_collection_collector = useContext(CheckboxCollectionContext);
  var _useContext = useContext(CheckboxCollectionContext),
    checked_items = _useContext.checked_items;
  var _useState = useState((_props$checked = props.checked) !== null && _props$checked !== void 0 ? _props$checked : false),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    set_checked = _useState2[1];
  useEffect(function () {
    if ((checked_items === null || checked_items === void 0 ? void 0 : checked_items.length) > 0) {
      set_checked(ArrayUtil["in"](checked_items, props.value));
    }
  }, [checked_items]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.base, checked && ui.checked), {
    onClick: function onClick() {
      if (!props.disabled) {
        var _checkbox_collection_, _props$__click;
        set_checked(!checked);
        checkbox_collection_collector === null || checkbox_collection_collector === void 0 || (_checkbox_collection_ = checkbox_collection_collector.__collect) === null || _checkbox_collection_ === void 0 || _checkbox_collection_.call(checkbox_collection_collector, props.value, !checked);
        (_props$__click = props.__click) === null || _props$__click === void 0 || _props$__click.call(props, !checked);
      }
    }
  }), /*#__PURE__*/React.createElement(Row, {
    gap: 10
  }, /*#__PURE__*/React.createElement(Col, {
    size: 2
  }, /*#__PURE__*/React.createElement(ColorIcon, {
    icon: "".concat(checked ? 'check' : 'minus'),
    size: 18,
    background_color: "".concat(checked ? props.disabled ? '' : '#2f851e' : props.disabled ? 'var(--shade-05)' : 'var(--shade-20)')
  })), /*#__PURE__*/React.createElement(Col, {
    size: 11
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: checked ? "var(--text-on-accent)" : "var(--text-color)"
    }
  }, props.label)))));
}
Checkbox.propTypes = {
  label: PropTypes.string,
  caption: PropTypes.string,
  checked: PropTypes.bool,
  __click: PropTypes.func,
  collection: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any
};

// @ts-ignore
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".ev12p33jh:active{background-color:var(--shade-15)}", 3170);
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1cy8zhl{align-items:flex-start}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
var ui = {
  base: {
    "Checkbox__ui.base": "Checkbox__ui.base",
    transition: "ev1m3phxg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "ev1y7ric0 ev3dtjww ev12p33jh",
    padding: "ev14odnwx",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    display: "ev78zum5",
    alignItems: "ev1cy8zhl",
    justifyContent: "evl56j7k",
    cursor: "ev1ypdohk",
    $$css: true
  },
  checked: {
    "Checkbox__ui.checked": "Checkbox__ui.checked",
    backgroundColor: "evwnonoy",
    $$css: true
  }
};